import { put, takeEvery, select, call } from 'redux-saga/effects'
import rpApiService from 'services/rp.api'
import { Action } from 'typescript-fsa'
import {
  apiMaximize,
  apiMinimize,
  apiSetField,
  apiSetFields,
  apiStartAgentChat,
  apiHideFloater,
  setLauncherState,
  defaultViewIdSelector
} from '../ui'
import { leadSelector } from '../lead/lead.selectors'
import { pingLead } from '../lead/lead.actions'
import { pingAgentConversation } from '../entities/conversations'
import { currentViewIdSelector, navigate } from '../router'
import { getStore } from '../../getStore'

export function* apiMinimizeSaga() {
  yield put(setLauncherState({ open: false }))
}

export function* apiMaximizeSaga() {
  yield put(setLauncherState({ open: true }))
  const state = getStore().getState()
  const homeViewId = currentViewIdSelector(state) || defaultViewIdSelector(state)
  yield put(navigate({ viewId: homeViewId }))
}

enum API_LEAD_FIELDS {
  EMAIL = 'clientEmail',
  PHONE = 'clientPhone',
  YEAR = 'vehicle.year',
  MAKE = 'vehicle.make',
  MODEL = 'vehicle.model',
  VIN = 'vehicle.vin',
  STOCK_NUMBER = 'vehicle.stockNumber',
  CUSTOM = 'additionalFields'
}

export function* apiSetFieldsSaga(
  action: Action<{
    fields: { fieldName: string; value: string; customName?: string }[]
  }>
) {
  yield put(pingLead({ performUpdate: true, withoutDelay: true }))
  const lead = yield select(leadSelector)
  let hasUpdate = false
  action.payload.fields.forEach(field => {
    switch (field.fieldName) {
      case API_LEAD_FIELDS.EMAIL:
        if (field.value !== lead.clientEmail) {
          hasUpdate = true
          lead.clientEmail = field.value
        }
        break
      case API_LEAD_FIELDS.PHONE:
        if (field.value !== lead.clientPhone) {
          hasUpdate = true
          lead.clientPhone = field.value
        }
        break
      case API_LEAD_FIELDS.YEAR:
        if (field.value !== lead.vehicleYear) {
          hasUpdate = true
          lead.vehicleYear = field.value
        }
        break
      case API_LEAD_FIELDS.VIN:
        if (field.value !== lead.vehicleVin) {
          hasUpdate = true
          lead.vehicleVin = field.value
        }
        break
      case API_LEAD_FIELDS.MAKE:
        if (field.value !== lead.vehicleMake) {
          hasUpdate = true
          lead.vehicleMake = field.value
        }
        break
      case API_LEAD_FIELDS.MODEL:
        if (field.value !== lead.vehicleModel) {
          hasUpdate = true
          lead.vehicleModel = field.value
        }
        break
      case API_LEAD_FIELDS.STOCK_NUMBER:
        if (field.value !== lead.vehicleStockNumber) {
          hasUpdate = true
          lead.vehicleStockNumber = field.value
        }
        break
      case API_LEAD_FIELDS.CUSTOM:
        if (field.customName) {
          if (
            !lead.additionalFields ||
            lead.additionalFields[field.customName] !== field.value
          ) {
            hasUpdate = true
            if (!lead.additionalFields) {
              lead.additionalFields = { [field.customName]: field.value }
            } else {
              lead.additionalFields[field.customName] = field.value
            }
          }
        }
        break
      default:
        break
    }
  })
  if (hasUpdate) {
    yield call(rpApiService.patchLead, lead._id, lead)
  }
}

export function* apiSetFieldSaga(
  action: Action<{ fieldName: string; value: string; customName?: string }>
) {
  const { fieldName, value, customName } = action.payload
  yield pingLead({ performUpdate: false, withoutDelay: true })
  const lead = yield select(leadSelector)
  switch (fieldName) {
    case API_LEAD_FIELDS.EMAIL:
      if (value !== lead.clientEmail) {
        lead.clientEmail = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.PHONE:
      if (value !== lead.clientPhone) {
        lead.clientPhone = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.YEAR:
      if (value !== lead.vehicleYear) {
        lead.vehicleYear = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.VIN:
      if (value !== lead.vehicleVin) {
        lead.vehicleVin = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.MAKE:
      if (value !== lead.vehicleMake) {
        lead.vehicleMake = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.MODEL:
      if (value !== lead.vehicleModel) {
        lead.vehicleModel = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.STOCK_NUMBER:
      if (value !== lead.vehicleStockNumber) {
        lead.vehicleStockNumber = value
      } else {
        return
      }
      break
    case API_LEAD_FIELDS.CUSTOM:
      if (customName) {
        if (
          !lead.additionalFields ||
          lead.additionalFields[customName] !== value
        ) {
          if (!lead.additionalFields) {
            lead.additionalFields = { [customName]: value }
          } else {
            lead.additionalFields[customName] = value
          }
        } else {
          return
        }
      } else {
        return
      }
      break
    default:
      return
  }
  yield call(rpApiService.patchLead, lead._id, lead)
}

export function* apiStartAgentChatSaga() { // action: Action<{ initialQuestion?: string}>) {
  // TODO: add initial question
  // const initialQuestion = action.payload.initialQuestion
  yield put(pingAgentConversation({ pathId: 'agent' })) // , initialQuestion}))
}

export function apiHideFloaterSaga() {
  console.error('Hide floater API not implemented')
}

export function* initApiSaga() {
  yield takeEvery(apiMinimize, apiMinimizeSaga)
  yield takeEvery(apiMaximize, apiMaximizeSaga)
  yield takeEvery(apiSetField, apiSetFieldSaga)
  yield takeEvery(apiSetFields, apiSetFieldsSaga)
  yield takeEvery(apiStartAgentChat, apiStartAgentChatSaga)
  yield takeEvery(apiHideFloater, apiHideFloaterSaga)
}
